
import {IGraphAxis, IGraphMetric} from "../PA.UIM.Metric/PA.UIM.Graph.IF";


//
// Define Metrics for each Axis
//

//<editor-fold desc="Model Prediction Axis - ">

//<editor-fold desc="Model Prediction Axis - Metrics">


//-- Model Output Units

const MODEL_PREDICTED_BASE_UNITS: IGraphMetric = {
  id: "PREDICTED_BASE_UNITS",
  name: "Predicted Base Units",
  sort: 10,
  renderOptions: {},
  components: [
    {id: "PREDICTED_BASE_UNITS",
      name: "Predicted Base Units",
      metricFieldName: "PREDICTED_BASE_UNITS",
      periodMetricsPath: "CalcTotal",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"PREDICTED_BASE_UNITS": '*'},
            properties: {color : "#A59487"},
            displayName: "Predicted Base Units"
          }
        }
      }
    }
  ]
}

const MODEL_PREDICTED_INCR_UNITS: IGraphMetric = {
  id: "PREDICTED_INCR_UNITS",
  name: "Predicted Incr Units",
  sort: 20,
  renderOptions: {},
  components: [
    {id: "PREDICTED_INCR_UNITS",
      name: "Predicted Incr Units",
      metricFieldName: "PREDICTED_INCR_UNITS",
      periodMetricsPath: "CalcTotal",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"PREDICTED_INCR_UNITS": '*'},
            properties: {color : "#CBF4C9"},
            displayName: "Predicted Incr Units"
          }
        }
      }
    }
  ]
}

const MODEL_PREDICTED_UNITS: IGraphMetric = {
  id: "PREDICTED_UNITS",
  name: "Predicted Total Units",
  sort: 30,
  renderOptions: {},
  components: [
    {id: "PREDICTED_UNITS_CMP",
      name: "Predicted Total Units",
      metricFieldName: "PREDICTED_UNITS",
      periodMetricsPath: "CalcTotal",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"PREDICTED_UNITS_CMP": '*'},
            properties: {color : "#0080FF", lineColor : "#0080FF", lineType : "line"},
            displayName: "Predicted Total Units"
          }
        }
      }
    }
  ]
}

const TARGET_OBSERVATION_UNITS: IGraphMetric = {
  id: "OBSERVED_UNITS",
  name: "Observed Total Units",
  sort: 40,
  renderOptions: {},
  components: [
    {id: "OBSERVED_UNITS_CMP",
      name: "Observed Total Units",
      metricFieldName: "TARGET_OBSERVATION_UNITS",
      periodMetricsPath: "CalcTotal",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"OBSERVED_UNITS_CMP": '*'},
            properties: {color : "#04A50D", lineColor : "#04A50D", lineType : "line"},
            displayName: "Observed Total Units"
          }
        }
      }
    }
  ]
}


//-- Model Output Retail Sales
const MODEL_PREDICTED_BASE_RTLSLS: IGraphMetric = {
  id: "PREDICTED_BASE_RTLSLS",
  name: "Predicted Base Retail Sales",
  sort: 10,
  renderOptions: {},
  components: [
    {id: "PREDICTED_BASE_RTLSLS_CMP",
      name: "Predicted Base Retail Sales",
      metricFieldName: "PREDICTED_BASE_RTLSLS",
      periodMetricsPath: "CalcTotal",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"PREDICTED_BASE_RTLSLS_CMP": '*'},
            properties: {color : "#A59487"},
            displayName: "Predicted Base Retial Sales"
          }
        }
      }
    }
  ]
}

const MODEL_PREDICTED_INCR_RTLSLS: IGraphMetric = {
  id: "PREDICTED_INCR_RTLSLS",
  name: "Predicted Incr Retail Sales",
  sort: 20,
  renderOptions: {},
  components: [
    {id: "PREDICTED_INCR_RTLSLS_CMP",
      name: "Predicted Incr Retail Sales",
      metricFieldName: "PREDICTED_INCR_RTLSLS",
      periodMetricsPath: "CalcTotal",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"PREDICTED_INCR_RTLSLS_CMP": '*'},
            properties: {color : "#CBF4C9"},
            displayName: "Predicted Incr Retail Sales"
          }
        }
      }
    }
  ]
}

const MODEL_PREDICTED_RTLSLS: IGraphMetric = {
  id: "PREDICTED_RTLSLS",
  name: "Predicted Total Retail Sales",
  sort: 30,
  renderOptions: {},
  components: [
    {id: "PREDICTED_RTLSLS_CMP",
      name: "Predicted Total Retail Sales",
      metricFieldName: "PREDICTED_RTLSLS",
      periodMetricsPath: "CalcTotal",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"PREDICTED_RTLSLS_CMP": '*'},
            properties: {color : "#0080FF"},
            displayName: "Predicted Total Retail Sales"
          }
        }
      }
    }
  ]
}

const TARGET_OBSERVATION_RTLSLS: IGraphMetric = {
  id: "OBSERVED_RTLSLS",
  name: "Observed Total Retail Sales",
  sort: 40,
  renderOptions: {},
  components: [
    {id: "OBSERVED_RTLSLS_CMP",
      name: "Observed Total Retail Sales",
      metricFieldName: "TARGET_OBSERVATION_RTLSLS",
      periodMetricsPath: "CalcTotal",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"OBSERVED_RTLSLS_CMP": '*'},
            properties: {color : "#04A50D", lineColor : "#04A50D", lineType : "line"},
            displayName: "Observed Total Retail Sales"
          }
        }
      }
    }
  ]
}


//-- Observations
const OBSERVATION_BASE_COUNT: IGraphMetric = {
  id: "OBSERVATION_BASE_COUNT",
  name: "Base Observation Count",
  sort: 10,
  renderOptions: {},
  components: [
    {id: "OBSERVATION_BASE_COUNT_CMP",
      name: "Base Observation Count",
      metricFieldName: "OBSERVATION_BASE_COUNT",
      periodMetricsPath: "CalcTotal",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"OBSERVATION_BASE_COUNT_CMP": '*'},
            properties: {color : "#A59487", pattern : "diagonalStripe"},
            displayName: "Observed Base Count"
          }
        }
      }
    }
  ]
}

const OBSERVATION_INCR_COUNT: IGraphMetric = {
  id: "OBSERVATION_INCR_COUNT",
  name: "Promoted Observation Count",
  sort: 20,
  renderOptions: {},
  components: [
    {id: "OBSERVATION_INCR_COUNT_CMP",
      name: "Promoted Observation Count",
      metricFieldName: "OBSERVATION_INCR_COUNT",
      periodMetricsPath: "CalcTotal",
      renderOptions: {ui5: { dataShape: "bar",
          dataPointRule: {
            dataContext: {"OBSERVATION_INCR_COUNT_CMP": '*'},
            properties: {color : "#CBF4C9", pattern : "diagonalStripe"},
            displayName: "Observed Promoted Count"
          }
        }
      }
    }
  ]
}

const OBSERVATION_COUNT: IGraphMetric = {
  id: "OBSERVATION_COUNT",
  name: "Total Observation Count",
  sort: 30,
  renderOptions: {},
  components: [
    {id: "OBSERVATION_COUNT_CMP",
      name: "Total Observed Count",
      metricFieldName: "OBSERVATION_COUNT",
      periodMetricsPath: "CalcTotal",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"OBSERVATION_COUNT_CMP": '*'},
            properties: {color : "#000000", lineColor : "#000000", lineType : "line" },
            displayName: "Observed Count"
          }
        }
      }
    }
  ]
}





const RESIDUAL_MEAN_UNITS: IGraphMetric = {
  id: "RESIDUAL_MEAN_UNITS",
  name: "Residual Mean Units",
  sort: 10,
  renderOptions: {},
  components: [
    {id: "RESIDUAL_MEAN_UNITS_CMP",
      name: "Residual Mean Units",
      metricFieldName: "RESIDUAL_MEAN",
      periodMetricsPath: "CalcTotal",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"RESIDUAL_MEAN_UNITS_CMP": '*'},
            properties: {color : "#FF963A"},
            displayName: "Residual Mean Units"
          }
        }
      }
    }
  ]
}

const RESIDUAL_MEAN_STDDEV_UNITS: IGraphMetric = {
  id: "RESIDUAL_MEAN_P1_UNITS",
  name: "Residual Mean +/- Std Dev Units",
  sort: 20,
  renderOptions: {},
  components: [
    {id: "RESIDUAL_MEAN_P1_UNITS_CMP",
      name: "Residual Mean + 1 StdDev Units",
      metricFieldName: "RESIDUAL_MEAN_P1_STDDEV",
      periodMetricsPath: "CalcTotal",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"RESIDUAL_MEAN_P1_UNITS_CMP": '*'},
            properties: {color : "#000000", lineColor : "#000000", lineType : "line" },
            displayName: "Residual Mean + 1 StdDev Units"
          }
        }
      }
    },
    {id: "RESIDUAL_MEAN_M1_UNITS_CMP",
      name: "Residual Mean - 1 StdDev Units",
      metricFieldName: "RESIDUAL_MEAN_M1_STDDEV",
      periodMetricsPath: "CalcTotal",
      renderOptions: {ui5: { dataShape: "line",
          dataPointRule: {
            dataContext: {"RESIDUAL_MEAN_M1_UNITS_CMP": '*'},
            properties: {color : "#000000", lineColor : "#000000", lineType : "line" },
            displayName: "Residual Mean - 1 StdDev Units"
          }
        }
      }
    }

  ]
}



//</editor-fold>

export const  ModelOutputUnitsAxis: IGraphAxis = {
  id: "Model_Output_Units",
  name: "Model Output - Units",
  renderOptions: {ui5: {
      resourceName: "ModelOutputUnitsAxisName",
      vizPropertiesAxis: {
        title: {
          visible: true,
          text: "Model Output (Units)"
        }
      },
      vizPropertiesPlotArea: {

      }
    }
  },
  metrics:
    [ MODEL_PREDICTED_BASE_UNITS,
      MODEL_PREDICTED_INCR_UNITS,
      MODEL_PREDICTED_UNITS,
      TARGET_OBSERVATION_UNITS],

  defaultRenderedMetricIds: [
    MODEL_PREDICTED_BASE_UNITS.id,
    MODEL_PREDICTED_INCR_UNITS.id,
    TARGET_OBSERVATION_UNITS.id
  ]

}

export const  ModelResidualUnitsAxis: IGraphAxis = {
  id: "Model_Residual_Units",
  name: "Residual - Units",
  renderOptions: {ui5: {
      resourceName: "ModelResidualUnitsAxisName",
      vizPropertiesAxis: {
        title: {
          visible: true,
          text: "Residual (Units)"
        }
      },
      vizPropertiesPlotArea: {

      }
    }
  },
  metrics:
    [ RESIDUAL_MEAN_UNITS,
      RESIDUAL_MEAN_STDDEV_UNITS],

  defaultRenderedMetricIds: [
    RESIDUAL_MEAN_UNITS.id,
    RESIDUAL_MEAN_STDDEV_UNITS.id
  ]

}



export const  ModelOutputRetailSalesAxis: IGraphAxis = {
  id: "Model_Output_Retail_Sales",
  name: "Model Output - Retail Sales",
  renderOptions: {ui5: {
      resourceName: "ModelOutputRetailSalesAxisName",
      vizPropertiesAxis: {
        title: {
          visible: true,
          text: "Model Output (Retail Sales)"
        }
      },
      vizPropertiesPlotArea: {}
    }
  },
  metrics: [MODEL_PREDICTED_BASE_RTLSLS, MODEL_PREDICTED_INCR_RTLSLS, MODEL_PREDICTED_RTLSLS,TARGET_OBSERVATION_RTLSLS],

  defaultRenderedMetricIds: [
    MODEL_PREDICTED_BASE_RTLSLS.id,
    MODEL_PREDICTED_INCR_RTLSLS.id,
    TARGET_OBSERVATION_RTLSLS.id
  ]

}

export const ModelObservationCountAxis: IGraphAxis = {
  id: "Model_Observations_Count",
  name: "Model Observations - Count",
  renderOptions: {ui5: {
      resourceName: "ModelObservationCountAxisName",
      vizPropertiesAxis: {
        title: {
          visible: true,
          text: "Model Observations (Count)"
        }
      },
      vizPropertiesPlotArea: {}
    }
  },
  metrics: [OBSERVATION_BASE_COUNT, OBSERVATION_INCR_COUNT, OBSERVATION_COUNT],

  defaultRenderedMetricIds: [
    OBSERVATION_BASE_COUNT.id,
    OBSERVATION_INCR_COUNT.id
  ]

}

export const ModelingSessionAxisList: IGraphAxis[] = [
  ModelOutputUnitsAxis,
  ModelResidualUnitsAxis,
  ModelObservationCountAxis,
  ModelOutputRetailSalesAxis
]

//</editor-fold>





